import { useSupportSheet } from "../../components/SupportSheet";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
  CashSpecialIcon,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { SupportStrokeIcon } from "../../assets/icons";
import { useStore } from "../../store/globalState";
import { CONSUMER_AUTH_ROUTES } from "../../constants";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { Navbar } from "../../components/Navbar";

/**
 * Gallery-safe later interstitial (fund-request). Pay now → consumer-auth mock.
 */
export const IntentionLaterPage = memo(() => {
  const { t } = useTranslation("fund-request");
  const { theme } = useStore();
  const navigate = useNavigate();
  const { openSupport, supportSheet } = useSupportSheet("fund-request");

  const colorConfig = theme.errorView;
  const {
    backgroundBtn,
    textColorBtn,
    title,
    bodyCopy,
    footerColor,
    iconColors,
    backgroundIcon,
  } = colorConfig;

  return (
    <>
    <AuraLayout colorConfig={colorConfig} className="need-help-header flow-landing-page">
      <Layout.Header>
        <Navbar
          title={t("common.needHelp")}
          align="right"
          noBackButton
          color={title}
          onIconClick={openSupport}
          icon={
            <SupportStrokeIcon
              size={35}
              colors={[backgroundIcon, backgroundIcon]}
              glyphColor={iconColors[0]}
            />
          }
        />
      </Layout.Header>
      <Layout.Content className="landing-section flow-hero-section flow-hero-section--with-header">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <CashSpecialIcon size={60} colors={iconColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("fundRequest.laterScreen.highlight")}
              highlightColor={title}
              secudnary={t("fundRequest.laterScreen.secondary")}
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t("fundRequest.laterScreen.body")}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <BodyCopy textColor={footerColor} className="footer-text">
            {t("fundRequest.laterScreen.changedMind")}
          </BodyCopy>
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(CONSUMER_AUTH_ROUTES.SIGN_IN)}
          >
            {t("fundRequest.laterScreen.cta")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
      {supportSheet}
    </>
  );
});
